




import { Component, Mixins } from "vue-property-decorator";
import DoKoSvgImgMixin from "../../components/mixins/DoKoSvgImgMixin.vue";

@Component({ components: {} })
export default class DoKoAvatar extends Mixins(DoKoSvgImgMixin) {
  readonly imgList = "avatar";
}
